<script>
import PublishTooltipButton from '../common/publish-tooltip-button.vue'

export default {
    name: 'settings-container',
    components: { PublishTooltipButton },
    props: {
        title: String,
        initiallyOpen: Boolean
    },
    data() {
        return {
            collapsed: !this.initiallyOpen,
            contentDisplayed: false,
            overflowHidden: true,

            t_expand: Lang.langGet('Expand'),
            t_collapse: Lang.langGet('Collapse')
        }
    },
    computed: {
        tooltip() {
            return `${this.collapsed ? this.t_expand : this.t_collapse} ${this.title}`
        }
    },
    methods: {
        onExpandCollapse() {
            if (!this.contentDisplayed) {
                this.contentDisplayed = true
                setTimeout(() => this.collapsed = false, 4)
            } else {
                this.collapsed = !this.collapsed
            }
        },
        onTransitionEnd(event) {
            //console.log('onTransitionEnd', event)
            if (event.propertyName != 'grid-template-rows') return

            if (this.collapsed) {
                this.contentDisplayed = false
            } else {
                this.overflowHidden = false
            }
        }
    },
    watch: {
        collapsed: {
            handler(val) {
                if (!val) {
                    this.contentDisplayed = true;
                } else {
                    this.overflowHidden = true;
                }
            },
            immediate: true
        },
        initiallyOpen: {
            handler(val) {
                this.collapsed = !val;
            },
            immediate: true
        }
    }
}
</script>

<template>
    <div>
        <div v-ripple
             class="settings-title-container"
             @click="onExpandCollapse"
             type="button"
             :aria-label="tooltip">
            <span class="flex-grow-1 pa-4"
                  style="font-size: 14px; font-weight: 600">
                {{ title }}
            </span>
            <v-card-actions>
                <publish-tooltip-button
                    icon="fas fa-chevron-down"
                    :tooltipText="tooltip"
                    @click.stop="onExpandCollapse"
                    :class="['collapsible-button-transition', {'fa-rotate-180': !collapsed}]"
                />
            </v-card-actions>
        </div>
        <div v-if="contentDisplayed"
             ref="container"
             :class="[
                'settings-content-container',
                {
                    'settings-content-expanded': !collapsed
                }
             ]"
             @transitionend.self="onTransitionEnd($event)">
            <div class="pt-2" :class="{'collapsible-overflow-hidden': overflowHidden}">
                <slot />
            </div>
        </div>
    </div>
</template>
